import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  TextField,
  Slide,
  Snackbar,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import LoadTypeDependents from "components/services/LoadTypeDependents";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewDependentsAdmin(props) {
  const classes = useStyles();

  const [loaderSave, setLoaderSave] = useState(false);
  const [dateBirthDependent, setDateBirthDependent] = useState();
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    nameDependent1: "",
    nameDependent2: "",
    lastNameDependent1: "",
    lastNameDependent2: "",
    documentIdDependent: "",
    dateBirthDependent: "",
    typePerson: "",
    typePersonName: "",
    typePersonData: "",
    errorNameDependent1: false,
    errorLastNameDependent1: false,
    errorDocumentIdDependent: false,
    errorDateBirthDependent: false,
    errorTypePerson: false,
  });

  const handleChange = (prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
      errorNameDependent1: false,
      errorLastNameDependent1: false,
      errorDocumentIdDependent: false,
      errorDateBirthDependent: false,
      errorTypePerson: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const handleChangeTypePerson = (data) => {
    setValues({
      ...values,
      typePerson: data !== null ? data.id : "",
      typePersonName: data !== null ? data.name : "",
      typePersonData: data !== null ? data : "",
      errorTypePerson: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const handleDateBirthDependentChange = (data) => {
    const formattedDate = dayjs(data).format("YYYY-MM-DD");

    setValues({
      ...values,
      dateBirthDependent: formattedDate,
      errorDateBirthDependent: false,
    });

    setDateBirthDependent(data);
  };

  const submitSave = async () => {
    setError(false);
    setLoaderSave(true);

    const validations = {
      nameDependent1: {
        value: values.nameDependent1,
        message: "Agregue un nombre del familiar.",
      },
      lastNameDependent1: {
        value: values.lastNameDependent1,
        message: "Agregue un apellido del familiar.",
      },
      documentIdDependent: {
        value: values.documentIdDependent,
        message: "Agregue un documento de identidad.",
      },
      dateBirthDependent: {
        value: values.dateBirthDependent,
        message: "Agregue la fecha de nacimiento.",
      },
      typePerson: {
        value: values.typePerson,
        message: "El campo tipo de persona es obligatorio.",
      },
    };

    for (const [key, { value, message }] of Object.entries(validations)) {
      if (value.length === 0) {
        setValues((prev) => ({
          ...prev,
          [`error${key.charAt(0).toUpperCase() + key.slice(1)}`]: true,
        }));
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "error",
          mensaje: message,
        });

        setLoaderSave(false);
        return; // Salir si hay un error
      }
    }

    const rowsItem = {
      id: (Math.floor(Math.random() * 900000) + 100000).toString(),
      nameDependent1: values.nameDependent1,
      nameDependent2: values.nameDependent2,
      lastNameDependent1: values.lastNameDependent1,
      lastNameDependent2: values.lastNameDependent2,
      allNames:
        values.nameDependent1 +
        " " +
        values.nameDependent2 +
        " " +
        values.lastNameDependent1 +
        " " +
        values.lastNameDependent2,
      documentIdDependent: values.documentIdDependent,
      dateBirthDependent: values.dateBirthDependent,
      typePersonId: values.typePerson,
      typePersonName: values.typePersonName,
      status: 1,
    };

    // Aquí está la clave para agregar el nuevo objeto al array
    const updatedRows = [...props.row, rowsItem];

    const data = {
      dependents: JSON.stringify(updatedRows),
    };

    try {
      const response = await axios.put(
        `${urlServices}clients/${props.idClient}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        props.callBackRefresh(1, updatedRows);
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "success",
          mensaje: "Registro con éxito.",
        });
        setValues({
          ...values,
          nameDependent1: "",
          nameDependent2: "",
          lastNameDependent1: "",
          lastNameDependent2: "",
          documentIdDependent: "",
          dateBirthDependent: "",
          typePerson: "",
          typePersonName: "",
          typePersonData: "",
        });
        setDateBirthDependent();
        setLoaderSave(false);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }

      setLoaderSave(false);
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const handleCloseDialog = () => () => {
    props.exit();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog()}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        maxWidth={"sm"}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
                <div className={classes.titleCardFilter}>
                  Registrar familiar
                </div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="nameDependent1"
                  value={values.nameDependent1}
                  error={values.errorNameDependent1}
                  onChange={(event) =>
                    handleChange("nameDependent1", event.target.value)
                  }
                  fullWidth
                  required
                  label="Primer nombre"
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="nameDependent2"
                  value={values.nameDependent2}
                  onChange={(event) =>
                    handleChange("nameDependent2", event.target.value)
                  }
                  fullWidth
                  label="Segundo nombre"
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastNameDependent1"
                  value={values.lastNameDependent1}
                  error={values.errorLastNameDependent1}
                  onChange={(event) =>
                    handleChange("lastNameDependent1", event.target.value)
                  }
                  fullWidth
                  required
                  label="Primer apellido"
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastNameDependent2"
                  value={values.lastNameDependent2}
                  onChange={(event) =>
                    handleChange("lastNameDependent2", event.target.value)
                  }
                  fullWidth
                  label="Segundo apellido"
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="documentIdDependent"
                  value={values.documentIdDependent}
                  error={values.errorDocumentIdDependent}
                  onChange={(event) =>
                    handleChange("documentIdDependent", event.target.value)
                  }
                  fullWidth
                  required
                  label="Nro. de documento"
                  margin="dense"
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                  type="number"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      name="dateBirthDependent"
                      label="Fecha de nacimiento"
                      value={dateBirthDependent}
                      onChange={(newValue) =>
                        handleDateBirthDependentChange(newValue)
                      }
                      format="DD/MM/YYYY"
                      sx={{
                        "& .MuiButtonBase-root": {
                          color: "#333",
                        },
                        width: "100%",
                        background: "#FFFFFF",
                      }}
                      slotProps={{
                        textField: {
                          // helperText: "DD/MM/YYYY",
                          error: values.errorDateBirthDependent,
                          required: true,
                          size: "small",
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <LoadTypeDependents
                  value={values.typePersonData}
                  refresh={handleChangeTypePerson}
                  error={values.errorTypePerson}
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ margin: "20px 0 15px 0" }}>
                <center>
                  <ButtonStyle0
                    onClick={submitSave}
                    endIcon={<Save />}
                    disabled={loaderSave}
                  >
                    {loaderSave ? "Registrando..." : "Registrar"}
                  </ButtonStyle0>
                </center>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog()}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
